var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.332031,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#F4F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.332 36C51.332 35.6647 51.325 35.3313 51.3112 35C50.8683 24.4189 43.4358 16 34.332 16C25.2282 16 17.7958 24.4189 17.3529 35C17.339 35.3313 17.332 35.6647 17.332 36",
    stroke: "#ADBAD1",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7668 46C51.6313 46 52.332 46.8176 52.332 47.8261C52.332 54.5496 47.6602 60 41.8972 60C41.0328 60 40.332 59.1824 40.332 58.1739C40.332 57.1654 41.0328 56.3478 41.8972 56.3478C45.9313 56.3478 49.2016 52.5325 49.2016 47.8261C49.2016 46.8176 49.9024 46 50.7668 46Z",
    fill: "#ADBAD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.332 48.8169C49.332 48.9191 49.4057 49.0021 49.4964 49C51.5586 48.9523 53.5274 48.0098 54.9889 46.3653C56.4892 44.6771 57.332 42.3874 57.332 40C57.332 37.6126 56.4892 35.3229 54.9889 33.6347C53.5274 31.9902 51.5586 31.0477 49.4964 31C49.4057 30.9979 49.332 31.0809 49.332 31.1831V40L49.332 48.8169Z",
    fill: "#37435A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.332 48.8203C19.332 48.9206 19.2598 49.002 19.1707 49C17.1074 48.9532 15.1374 48.0106 13.6752 46.3652C12.1749 44.6771 11.332 42.3874 11.332 40C11.332 37.6126 12.1749 35.3229 13.6752 33.6348C15.1374 31.9894 17.1074 31.0468 19.1707 31C19.2598 30.998 19.332 31.0794 19.332 31.1797V40L19.332 48.8203Z",
    fill: "#37435A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4708 39.2745C44.4708 44.9316 39.8848 49.5177 34.2276 49.5177C28.5704 49.5177 23.9844 44.9316 23.9844 39.2745C23.9844 33.6173 28.5704 29.0312 34.2276 29.0312C39.8848 29.0312 44.4708 33.6173 44.4708 39.2745Z",
    fill: "#ADBAD1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2271 47.1572C38.5787 47.1572 42.1065 43.6295 42.1065 39.2778C42.1065 34.9262 38.5787 31.3984 34.2271 31.3984C29.8754 31.3984 26.3477 34.9262 26.3477 39.2778C26.3477 43.6295 29.8754 47.1572 34.2271 47.1572Z",
    fill: "#F7F9FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2249 40.4634C34.8776 40.4634 35.4068 39.9343 35.4068 39.2815C35.4068 38.6288 34.8776 38.0996 34.2249 38.0996C33.5721 38.0996 33.043 38.6288 33.043 39.2815C33.043 39.9343 33.5721 40.4634 34.2249 40.4634Z",
    fill: "#37435A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6211 39.198C34.6211 38.9409 34.8296 38.7324 35.0867 38.7324H38.8831C39.1403 38.7324 39.3487 38.9409 39.3487 39.198C39.3487 39.4552 39.1403 39.6636 38.8831 39.6636H35.0867C34.8296 39.6636 34.6211 39.4552 34.6211 39.198Z",
    fill: "#37435A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.157 38.8799C33.8999 38.8799 33.6914 38.6714 33.6914 38.4143L33.6914 34.6178C33.6914 34.3607 33.8999 34.1522 34.157 34.1522C34.4142 34.1522 34.6226 34.3607 34.6226 34.6178L34.6226 38.4143C34.6226 38.6714 34.4142 38.8799 34.157 38.8799Z",
    fill: "#37435A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.e3b77679e257ea987020ebfbca887248.svg";
export { ForwardRef as ReactComponent };